import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Button, { SIZE as VIEW, COLOR } from "components/Button";
import {  Loading } from "components/assets/Icons";

import PageHeader from "components/PageHeader";
import styles from './CreateTruck.module.scss'
import GeneralInfo from "./Components/GeneralInfo/GeneralInfo";
import DriverInfo from "./Components/DriverInfo";
import TruckInfo from "./Components/TruckInfo";
import PopUpSuccess from "./Components/PopUpSuccess";
import trucksService from "services/trucks.service";
import {isEmptyDriver, isEmpty} from './Components/helpers'

const CreateTruck = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false);
  const [currentScreen,] = useState({
    screen: "Create truck",
    title: "Create Truck",
  });
  const [success, setSuccess] = useState(false)

  const [fetchData, setFetchData] = useState({
    unit: null,
    associated_users_ids: [],
    dispatcher: {
      name: null,
      phone_number: null
    },
    drivers: [{
      name: null,
      phone_number: null,
      tsa_certificate: false,
      twic_certificate: false,
      hazmat_certificate: false,
      can_cross_us_can_border: false,
      us_citizen: false,
    },{
      name : null,
      phone_number: null
    } ],
    length: null,
    width: null,
    height: null,
    payload: null,
    air_ride: false,
    lift_gate: false,
    dock_high: false,
    pallet_jack: false,
    truck_note: null
  })
  const prevFetchDataRef = useRef(fetchData);


  const updateData = (field, indexOrId, value) => {
    setFetchData(prev => {
        if (field === 'drivers') {
            return {
                ...prev,
                drivers: prev.drivers.map((driver, idx) =>
                    idx === indexOrId ? { ...driver, ...value } : driver
                )
            };
        }
        if (field === 'associated_users_ids') {
          return {
              ...prev,
              associated_users_ids: value
          };
        }
        
        if (field === 'dispatcher') {
          return {
              ...prev,
              dispatcher: {
                  ...prev.dispatcher,
                  ...value
              }
          };
      }
      
        return {
            ...prev,
            [field]: typeof value === 'object' ? {
                ...prev[field],
                ...value
            } : value
        };
    });
};


// validation
const [associatedUserErr, setAssociatedUserErr] = useState('')
const [unitError, setunitError] = useState("")
const [dispatcherNameErr, setDispatcherNameErr] = useState("")
const [dispatcherPhoneErr, setDispatcherPhoneErr] = useState("")
const generalErrors = {associatedUserErr,unitError,dispatcherNameErr,dispatcherPhoneErr}

const [driverNameErr, setDriverNameErr] = useState("")
const [driverPhoneErr, setDriverPhoneErr] = useState("")
const driverErrors = {driverNameErr,driverPhoneErr}

const [boxLErr, setBoxLErr] = useState("")
const [boxWErr, setBoxWErr] = useState("")
const [boxHErr, setBoxHErr] = useState("")
const [maxPErr, setMaxPErr] = useState("")
const [noteErr, setNoteErr] = useState("")
const truckrErrors = {boxLErr,boxWErr, boxHErr, maxPErr, noteErr}

useEffect(() => {
  const prevFetchData = prevFetchDataRef.current;

  if(prevFetchData.associated_users_ids !== fetchData.associated_users_ids) setAssociatedUserErr('')
  if(prevFetchData.dispatcher?.name !== fetchData.dispatcher?.name) setDispatcherNameErr("")
  if(prevFetchData.dispatcher?.phone_number !== fetchData.dispatcher?.phone_number) setDispatcherPhoneErr("")
  if(prevFetchData.unit !== fetchData.unit) setunitError("")
  if(prevFetchData.drivers?.[0]?.name !== fetchData.drivers?.[0]?.name) setDriverNameErr("")
  if(prevFetchData.drivers?.[0]?.phone_number !== fetchData.drivers?.[0]?.phone_number) setDriverPhoneErr("")
  if(prevFetchData.length !== fetchData.length)setBoxLErr("")
  if(prevFetchData.width !== fetchData.width)setBoxWErr("")
  if(prevFetchData.height !== fetchData.height)setBoxHErr("")
  if(prevFetchData.payload !== fetchData.payload)setMaxPErr("")
  if(prevFetchData.truck_note !== fetchData.truck_note)setNoteErr("")

  prevFetchDataRef.current = fetchData;

}, [fetchData])

  const validate = () => {
    let associatedUser, unitError, driverNameErr,driverPhoneErr,boxLErr, boxWErr,boxHErr,maxPErr, noteErr
    
    //associated user
    if(fetchData?.associated_users_ids?.length < 1) {
      associatedUser = "This field is required"
      setAssociatedUserErr(associatedUser)
    }
    //unit
    if(isEmpty(fetchData?.unit)) {
      unitError = "This field is required"
      setunitError(unitError)
    } 
    if (fetchData?.unit?.length > 30){
      unitError = "Max 30 symbols"
      setunitError(unitError)
    }
    //dispatcher Name temporary not required
    // if (!fetchData.dispatcher.name) {
    //   setDispatcherNameErr("This field is required")
      
    // } else if(fetchData.dispatcher.name.length > 255) {
    //   setDispatcherNameErr("Max 255 symbols")
    // }
    // //dispatcher number temporary not required
    // if(fetchData.dispatcher.phone_number <3) {
    //   setDispatcherPhoneErr("This field is required")
    // } else if(fetchData.dispatcher.phone_number.length <16){
    //   setDispatcherPhoneErr("Phone number should be 10 digits")
    // }
    //driver 1 name
    if (!fetchData.drivers[0].name) {
      driverNameErr = "This field is required"
      setDriverNameErr(driverNameErr)
    } 
    if(fetchData?.drivers[0].name?.length > 255) {
      driverNameErr = "Max 255 symbols"
      setDriverNameErr(driverNameErr)
    }
    // driver 1 phone
    if(!fetchData?.drivers[0]?.phone_number) {
      driverPhoneErr = "This field is required"
      setDriverPhoneErr(driverPhoneErr)
    }  
    if(fetchData?.drivers[0]?.phone_number?.length <16){
      driverPhoneErr = "Phone number should be 10 digits"
      setDriverPhoneErr(driverPhoneErr)
    }
    // Box length
    if (isEmpty(fetchData?.length)) {
      boxLErr = "This field is required"
      setBoxLErr(boxLErr)
    } 
    if((+fetchData?.length?.length > 3)) {
      boxLErr = "max 3 symbols (value 999)"
      setBoxLErr(boxLErr)
    }
    //box width
    if (isEmpty(fetchData?.width)) {
      boxWErr = "This field is required"
      setBoxWErr(boxWErr)
    } 
    if((fetchData?.width?.length > 3)) {
      boxWErr = "max 3 symbols (value 999)"
      setBoxWErr(boxWErr)
    }
    // box heigth
    if (isEmpty(fetchData?.height)) {
      boxHErr = "This field is required"
      setBoxHErr(boxHErr)
    } 
    if(fetchData?.height?.length > 3) {
      boxHErr = "max 3 symbols (value 999)"
      setBoxHErr(boxHErr)
    }
    // max payload
    if (isEmpty(fetchData?.payload)) {
      maxPErr = "This field is required"
      setMaxPErr(maxPErr)
    } 
    if(fetchData?.payload?.length > 5) {
      maxPErr = "max 5 symbols (value 999)"
      setMaxPErr(maxPErr)
    }
    //length
    if (fetchData?.truck_note?.length > 255) {
      noteErr = "Max 255 symbols"
      setNoteErr(noteErr)
    }
    let finalCheck = !associatedUser && !unitError && 
      !driverNameErr && !driverPhoneErr && !boxLErr && !boxWErr &&
        !boxHErr && !maxPErr && !noteErr
    return finalCheck
  };

  const handleSubmit = () => {
    if(fetchData) {
      if(!validate()) return
      let dataForReq = fetchData

    // Remove driver[1] if it is empty or null
      if (isEmptyDriver(dataForReq.drivers[1])) {
        dataForReq.drivers.splice(1, 1); // Removes 1 element at index 1
      }
      
      setLoading(true)
      trucksService.createTrucks(dataForReq).then((res) => {
        if (res.status === 201) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          setSuccess("Truck created")
          setLoading(false)
        }
      }).catch((e) => {
        console.error("Create truck error:", e.response?.data)
        if(e.response?.data?.unit && e.response?.data?.unit[0]) setunitError(e.response?.data?.unit[0])
        if(e.response?.data?.drivers && e.response?.data?.drivers[0]) {
          setDriverNameErr(e.response?.data?.drivers[0].split("to")[0])
          setDriverPhoneErr(" ")
        }
        setLoading(false)
        // TODO: validate errors
      })
    }
  };

  return (
    <>
      <div className="container">
        <PageHeader title={currentScreen.title} />
        
        <GeneralInfo fetchData={fetchData} updateData={updateData} errors={generalErrors}/>
        <DriverInfo fetchData={fetchData} updateData={updateData} errors={driverErrors}/>
        <TruckInfo fetchData={fetchData} updateData={updateData} errors={truckrErrors}/>
        
        <div  className={styles.buttongroup}>
          <Button
            size={VIEW.MIDDLE}
            color={COLOR.GREY}
            onClick={() => navigate(-1)}
          >
            Back to Trucks
          </Button>
          <Button size={VIEW.MIDDLE} onClick={handleSubmit}>
            {loading ? <Loading /> : "Create Truck"}
          </Button>
        </div>
        {success && <PopUpSuccess text={success} />} 
      </div>
    </>
  );
};

export default CreateTruck;
